import { render } from "./TabResumen.vue?vue&type=template&id=05b286e4&scoped=true"
import script from "./TabResumen.vue?vue&type=script&lang=js"
export * from "./TabResumen.vue?vue&type=script&lang=js"

import "./TabResumen.vue?vue&type=style&index=0&id=05b286e4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b286e4"]])

export default __exports__